import React, { Component } from "react";

class IntroToDot extends Component {
  render() {
    return (
      <div>
        <div className="row" style={{ marginTop: 30 }}>
          <div className="col"></div>
          <h4 className="col">Introduction to Dot</h4>
          <div className="col"></div>
        </div>
      </div>
    );
  }
}

export default IntroToDot;



// WEBPACK FOOTER //
// ./src/pages/IntrotoDOT.js